module.exports = __webpack_public_path__ + "img/icon_1_0.ba547822.png";